export const scrollToFirstError = (): void => {
  if (document.querySelector('input:focus')) {
    return
  }
  document
    ?.querySelector('[aria-label="Alert solid"]')
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
